import { RoleAssignment } from '@/models';
import { GenericService } from './generic.service';

export class OrganisationRoleAssignmentService extends GenericService<RoleAssignment> {

  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/role-assignments`);
  }
}
